import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Fieldtypes } from '../../core/entities/fieldtypes.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FieldtypesService {
    readonly BASE: any = PETICIONES.fieldtypes;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los fieldtypes
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un fieldtypes por su id
   */
  public findById(id: number): Observable<any> {
    let idfieldtypes: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idfieldtypes).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un fieldtypes en la base de datos
   */
  public postFieldtype(fieldtypes: Fieldtypes): Observable<any> {
    const json = JSON.stringify(fieldtypes);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postFieldtypes, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un fieldtypes en la base de datos
   */
  public deleteFieldtype(fieldtypes: Fieldtypes): Observable<any> {
    let idfieldtypes: string = (fieldtypes.id !== undefined && fieldtypes.id !== null ? fieldtypes.id + "" : "");
    return this.http.get(this.BASE.deleteFieldtypes + "/" + idfieldtypes).pipe(delay(DELAY));
  }

}